import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  role: "menu"
}
const _hoisted_2 = {
  key: 0,
  class: "arrow"
}
const _hoisted_3 = { class: "layout-menuitem-text" }
const _hoisted_4 = {
  key: 0,
  class: "pi pi-fw pi-angle-down menuitem-toggle-icon"
}
const _hoisted_5 = {
  key: 1,
  class: "menuitem-badge"
}
const _hoisted_6 = ["href", "target", "onMouseenter", "onClick"]
const _hoisted_7 = { class: "layout-menuitem-text" }
const _hoisted_8 = {
  key: 0,
  class: "pi pi-fw pi-angle-down menuitem-toggle-icon"
}
const _hoisted_9 = {
  key: 1,
  class: "menuitem-badge"
}
const _hoisted_10 = {
  key: 3,
  class: "layout-menuitem-root-text",
  style: {"text-transform":"uppercase"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_appsubmenu = _resolveComponent("appsubmenu")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_ctx.items)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.label || i
          }, [
            (_ctx.visible(item) && !item.separator)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass([{
          'layout-root-menuitem': _ctx.root, 
          'active-menuitem': _ctx.activeIndex === i && !item.to && !item.disabled
        }]),
                  role: "none"
                }, [
                  (item.items && _ctx.root===true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                    : _createCommentVNode("", true),
                  (item.to)
                    ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: item.to,
                        style: _normalizeStyle(item.style),
                        class: _normalizeClass([
            item.class, 
            'p-ripple', 
            {'p-disabled': item.disabled},
            {'router-link-active': _ctx.isSubroute(item.to)}
          ]),
                        target: item.target,
                        exact: "",
                        onClick: ($event: any) => (_ctx.onMenuItemClick($event,item,i)),
                        onMouseenter: ($event: any) => (_ctx.onMenuItemMouseEnter(i)),
                        role: "menuitem"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass(['layout-menuitem-icon', item.icon])
                          }, null, 2),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1),
                          (item.items)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                            : _createCommentVNode("", true),
                          (item.badge)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.badge), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["to", "style", "class", "target", "onClick", "onMouseenter"])), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (!item.to)
                    ? _withDirectives((_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: item.url||'#',
                        style: _normalizeStyle(item.style),
                        class: _normalizeClass([item.class, 'p-ripple', {'p-disabled': item.disabled}]),
                        target: item.target,
                        onMouseenter: ($event: any) => (_ctx.onMenuItemMouseEnter(i)),
                        onClick: ($event: any) => (_ctx.onMenuItemClick($event,item,i)),
                        role: "menuitem"
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(['layout-menuitem-icon', item.icon])
                        }, null, 2),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1),
                        (item.items)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                          : _createCommentVNode("", true),
                        (item.badge)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.badge), 1))
                          : _createCommentVNode("", true)
                      ], 46, _hoisted_6)), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.root)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.label), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_Transition, { name: "layout-submenu-container" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_appsubmenu, {
                        items: _ctx.visible(item) && item.items,
                        onMenuitemClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('menuitem-click', $event))),
                        layoutMode: _ctx.layoutMode,
                        menuActive: _ctx.menuActive,
                        parentMenuItemActive: _ctx.activeIndex === i
                      }, null, 8, ["items", "layoutMode", "menuActive", "parentMenuItemActive"]), [
                        [_vShow, item.items && (_ctx.root && (!_ctx.isHorizontal() || (_ctx.isHorizontal() && (_ctx.mobileMenuActive || _ctx.activeIndex !== null))) ? true : _ctx.activeIndex === i)]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.visible(item) && item.separator)
              ? (_openBlock(), _createElementBlock("li", {
                  class: "p-menu-separator",
                  style: _normalizeStyle(item.style),
                  key: 'separator' + i,
                  role: "separator"
                }, null, 4))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}